import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export class CreateShiftForm {
  public userId: string = '';
  public shiftType: number = 0;
  public date: string = '';
  public overtime: number = 0;

  public rules: { [key: string]: FormValidationFunction[] } = {
    userId: [
      (v: string) => !!v || 'UserId field is required.',
    ],
    ShiftType: [
      (v: string) => !!v || 'ShiftType field is required.',
    ],
    date: [
      (v: string) => !!v || 'Data field is required.',
    ],
    overtime: [
      (v: number) => !(v < 0 || v > 24) || 'The overtime must be between 0 and 24. ',
    ],
  };
}
